import { render, staticRenderFns } from "./SysTooltip2.vue?vue&type=template&id=50df1e64&scoped=true"
import script from "./SysTooltip2.vue?vue&type=script&lang=js"
export * from "./SysTooltip2.vue?vue&type=script&lang=js"
import style0 from "./SysTooltip2.vue?vue&type=style&index=0&id=50df1e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df1e64",
  null
  
)

export default component.exports